import * as api from "~/api/resource";
import _ from "lodash";
import {mapActions, mapGetters} from "vuex";

let _rand = 0
export default {
    props: {},
    data() {
        return {
            // formDada: {},
            // loggedUser: null,
        };
    },
    computed: {},
    watch: {},
    methods: {
        aggregateTransBookings(rt, group_props, children_key, avoid_last_level, order_prop, parent_key) {
            // _log_("go aggregateTransBookings/pax_boarded/", rt, group_props, children_key, avoid_last_level, order_prop, parent_key);
            children_key = children_key ? children_key : 'children'
            order_prop = order_prop ? order_prop : 'strip_time'
            const ensure_number = order_prop == 'strip_time'
            const vm = this, repo = rt.bookings && rt.bookings?.length ? rt.bookings : rt
            if (!repo) return
            const group_prop = group_props.shift()
            const loc_order = rt.real_loc_seq ? rt.real_loc_seq : [], pup_order = rt.real_pup_seq ? rt.real_pup_seq : []

            // group_props = group_props.splice[0, 1]
            if (group_prop) {
                let grouped = _.groupBy(repo, item => item ? item[group_prop] : '...');

                let arrayGrouped = []
                for (const groupedKey in grouped) {
                    let groupedElement = grouped[groupedKey],
                        _id_groupedKey = (parent_key ? parent_key + '||' : '') + (groupedKey ? groupedKey : 'n/a' + (++_rand))
                    // _log_("go ahead/2/", groupedElement);

                    if (group_props.length && groupedElement) {
                        let newGroup = vm.aggregateTransBookings(groupedElement, JSON.parse(JSON.stringify(group_props)), children_key, avoid_last_level, order_prop, _id_groupedKey);
                        const pax = newGroup.reduce((partialSum, a) => partialSum + (a.pax ? a.pax * 1 : 0), 0);
                        const pax_checked = newGroup.reduce((partialSum,
                                                             a) => partialSum + (a.pax_checked ? a.pax_checked * 1 : 0)
                            , 0
                        );
                        const pax_boarded = newGroup.reduce((partialSum,
                                                             a) => partialSum + (a.pax_boarded ? a.pax_boarded : 0)
                            , 0
                        );
                        const aTripTime = newGroup.reduce((prev,
                                                           curr) => prev.finalPickupTime < curr.finalPickupTime ? prev : curr)
                        let classBk = '';
                        if (pax == pax_checked) classBk = 'bk-checked'
                        else if (pax_checked) classBk = 'bk-almost-checked'
                        let item = {
                            _groupProp: group_prop,
                            _sample: groupedElement[0],
                            text: vm.intToTime(aTripTime.finalPickupTime) + ' ' + groupedKey,
                            _order: newGroup[0]._order,
                            _id: _id_groupedKey,
                            className: classBk,
                            pax: pax,
                            checked_in: pax == pax_checked,
                            badge: pax_checked + '/' + pax,
                            pax_boarded: pax_boarded,
                            pax_checked: pax_checked * 1,
                            finalPickupTime: aTripTime.finalPickupTime ? aTripTime.finalPickupTime : aTripTime
                        };
                        item[children_key] = newGroup.sort((a,
                                                            b) => ensure_number ? (a._order - b._order) : (a._order > b._order ? 1 : (a._order === b._order ? 0 : -1)))
                        // _log_("go grouped/0/ item[children_key] ", item[children_key]);
                        arrayGrouped.push(item);
                        // arrayGrouped.push(newGroup)
                    }
                    else {
                        const pax1 = groupedElement.reduce((partialSum, a) => partialSum + (a && a.pax ? a.pax * 1 : 0)
                            , 0
                        );
                        const pax1_checked = groupedElement.reduce((partialSum,
                                                                    a) => partialSum + (a && a.pax && a.checked_in ? a.pax * 1 : 0)
                            , 0
                        );
                        const pax1_boarded = groupedElement.reduce((partialSum,
                                                                    a) => partialSum + (a && a.routeNum ? a.pax * 1 : 0)
                            , 0
                        );
                        const aTripTime = groupedElement.reduce((prev,
                                                                 curr) => prev && prev.finalPickupTime < curr.finalPickupTime ? prev : curr)
                        // _log_("go ahead/2/", pax1_checked);
                        let classBk = '';
                        if (pax1 == pax1_checked) classBk = 'bk-checked'
                        else if (pax1_checked) classBk = 'bk-almost-checked'
                        let item1 = {
                            // children: groupedElement.map(el => {
                            //         return {
                            //             ...el,
                            //             _id: el.id,
                            //             text: '(' + el.pax + ') ' + el.customer_name,
                            //             order: pup_order.indexOf(el.ppid * 1)
                            //         }
                            //     }
                            // ).sort((a, b) => a._order - b._order),
                            _groupProp: group_prop,
                            _sample: groupedElement[0],
                            pax_checked: pax1_checked * 1,
                            pax_boarded: pax1_boarded,
                            badge: pax1_checked + '/' + pax1,
                            className: classBk,
                            checked_in: pax1 == pax1_checked,
                            text: (aTripTime ? vm.intToTime(aTripTime.finalPickupTime) + ' ' : '') + groupedKey,
                            _order: order_prop ? (ensure_number ? groupedElement[0][order_prop] * 1 : groupedElement[0][order_prop]) : pup_order.indexOf(groupedElement[0].ppid * 1),
                            _id: _id_groupedKey,//groupedKey ? groupedKey : 'n/a' + (++_rand),
                            pax: pax1,
                            finalPickupTime: aTripTime ? aTripTime.finalPickupTime : null
                        };
                        if (!avoid_last_level) item1[children_key] = groupedElement.map(el => {
                                // _log_("go ahead/pax_boarded/", el);
                                return el ? {
                                    ...el,
                                    pax_boarded: el.routeNum ? el.pax * 1 : 0,
                                    _id: el.id,
                                    text: '(' + el.pax + ') ' + el.customer_name,
                                    _order: order_prop ? (ensure_number ? el[order_prop] * 1 : el[order_prop]) : pup_order.indexOf(el.ppid * 1)
                                } : {}
                            }
                        )
                                                                                   .sort((a,
                                                                                          b) => ensure_number ? (a._order - b._order) : (a._order > b._order ? 1 : (a._order === b._order ? 0 : -1)))
                        arrayGrouped.push(item1)
                    }

                    // grouped[groupedKey] = {children:newGroup,id:groupedKey}
                }
                // _log_("go grouped/0/ arrayGrouped ", arrayGrouped);
                return arrayGrouped.sort((a,
                                          b) => ensure_number ? (a._order - b._order) : (a._order > b._order ? 1 : (a._order === b._order ? 0 : -1)))
            }
            return null
        }
    },
    mounted() {
    },
};
